<div class="notification-wrapper" ng-if="$ctrl.notificationVisible" ng-click="$ctrl.handleOk()" >
     <i ng-click="$ctrl.handleOk()" class="fa fa-close"> </i> 

   <p>{{$ctrl.message|translate}}</p>
</div>